var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSongsoptok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93445 15.2804L7.60041 28.2506H6.89081L6.75946 28.408V31.1649L6.62862 29.7186L5.8949 30.2703L4.19195 30.244L0 33.055H23.7638L18.5226 30.1931L16.7935 30.2446L16.6637 28.4332L16.323 28.118L15.7986 28.1442L14.4887 15.2804H12.2116L12.1603 13.4165L12.4481 11.526C12.4481 11.526 13.4178 11.9198 13.9155 11.1583C13.9155 11.1583 12.1603 8.82148 12.0551 7.92889C12.0551 7.92889 12.5004 7.79778 12.5533 7.56127C12.5533 7.56127 12.2649 6.93142 12.2649 6.56379C12.2649 6.56379 12.4743 6.14372 12.1074 6.09128L11.3711 6.27278L10.9771 5.59049C10.9771 5.59049 11.5805 4.56627 10.3229 4.11998C10.3229 4.11998 9.45832 4.01715 9.58915 5.11746C9.58915 5.11746 9.72051 5.53753 10.1135 5.74782L10.3752 6.4044C10.3752 6.4044 10.192 6.66663 9.74667 6.37818L7.78154 4.8357C7.78154 4.8357 7.49113 3.54772 6.75946 3.44129C6.75946 3.44129 5.2402 1.94508 5.03034 1.86641L2.93437 0L2.72503 0.131111L4.40181 1.9168L5.55472 3.12456L5.42337 3.33434L5.58089 3.51841L5.8164 3.43923C5.8164 3.43923 5.94724 3.91226 6.10475 4.01715C6.10475 4.01715 6.52395 4.51589 6.73329 4.51589C6.73329 4.51589 7.78154 6.48513 7.62453 6.80031L8.25307 6.77357L8.01756 5.95965C8.01756 5.95965 11.0828 9.50429 10.7944 10.9223C10.7944 10.9223 11.1613 12.6026 11.1351 13.0489L11.2926 15.2279L8.93445 15.2804Z",
    fill: "#0077B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7638 33.0549H0V34H23.7638V33.0549Z",
    fill: "#023E8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongsoptok);
export default __webpack_public_path__ + "static/media/songsoptok.3ab49e7e527fe1ac52736a177491677c.svg";
export { ForwardRef as ReactComponent };